import { Title, Stack, Anchor, Group } from '@mantine/core';
import Icon from '@ui/components/Icon/Icon';
import Text from '@ui/components/Text/Text';
import Project from 'src/entities/project';
import DownloadsEnabledForReviewersSwitch from './DownloadsEnabledForReviewersSwitch/DownloadsEnabledForReviewersSwitch';
import HideCommentsForReviewersSwitch from './HideCommentsForReviewsSwitch/HideCommentsForReviewersSwitch';

export type ProjectPermissionsProps = {
	project: Project;
	modalsStackOrder?: number;
};

const ProjectPermissions = ( { project, modalsStackOrder = 1 }: ProjectPermissionsProps ) => (
	<Stack spacing={15} w="100%">
		<Title order={5}>Reviewer Role</Title>
		<Stack spacing={10} w="100%">
			<DownloadsEnabledForReviewersSwitch project={project} />
			<HideCommentsForReviewersSwitch project={project} modalsStackOrder={modalsStackOrder} />
		</Stack>
		<Anchor href="https://support.verybusy.io/en/articles/10523752-understanding-user-roles-and-permissions-within-a-project" target="_blank">
			<Group spacing={4}>
				<Icon icon="info_outlined" size={14} color="var(--color-text-primary)" />
				<Text variant="footnote" color="var(--color-text-primary)">Learn about roles and permissions</Text>
			</Group>
		</Anchor>
	</Stack>
);

export default ProjectPermissions;
